import { TableRow } from './tableStyles';

export default ({ i18n }) => (
  <thead>
    <TableRow>
      <th className="time">{i18n.t('time')}</th>
      <th className="patient" style={{ paddingLeft: '30px', textAlign: 'left' }}>
        {i18n.t('patient')}
      </th>
      <th className="ap-type">{i18n.t('appointment_type')}</th>
      <th className="note">{i18n.t('note')}</th>
      <th className="certificate">{i18n.t('cert')}</th>
      <th className="triggers">{i18n.t('status')}</th>
    </TableRow>
  </thead>
);
